import { ReactNode } from 'react';

const colorStyles = {
  none: '',

  default:
    'bg-[#EAEAEA] dark:bg-[#333333] hover:bg-[#BBBBBB] dark:hover:bg-[#292929] disabled:text-[rgba(255,255,255,0.3)]',
  gradient:
    'text-white bg-gradient-to-r from-[#ff3496] to-[#ff7700] disabled:from-[#ff3496] disabled:to-[#ff7700] disabled:opacity-20',
  transparent: 'bg-transparent disabled:bg-[#393939] disabled:opacity-70',
  white: 'bg-white',
  red: 'text-white bg-[#FF4066] hover:bg-[#D7677C] dark:bg-[#B63851] dark:hover:bg-[#c56074]',
  primary: 'bg-[#FF3496] text-white hover:bg-[#5c5c5c]',

  // component
  chat: 'bg-[#FFFFFF] dark:bg-[#333333] hover:bg-[#000000]/15 dark:hover:bg-[#616161]',
  mic: 'bg-transparent hover:bg-[#000000]/30 dark:hover:bg-[#FFFFFF]/20',
  zoom: 'bg-transparent hover:bg-[##000000]/15 dark:hover:bg-[#393939] disabled:opacity-70',
  popup:
    'bg-[#BDBDBD] dark:bg-[#262626] hover:bg-[#404040] dark:hover:bg-[#565656] disabled:opacity-20',

  // sidebar
  side: 'bg-[#EAEAEA] dark:bg-[#333333] hover:bg-[#303030] dark:hover:bg-[#5C5C5C] text-[#404040] dark:text-white hover:text-white disabled:opacity-20',
  right:
    'bg-[#DCDCDC] hover:bg-[#404040] dark:bg-[#262626] dark:hover:bg-[#565656] text-[#404040] dark:text-white hover:text-white',

  // modal
  modal:
    'bg-[#404040] dark:bg-[#565656] hover:bg-[#787878] dark:hover:bg-[#898989] disabled:opacity-20 text-white',

  // edit
  editExport: 'bg-[#EAEAEA] hover:bg-[#EAEAEA]/20 dark:bg-[#303030] dark:hover:bg-[#565656]',
  editAdd: 'bg-[#565656] dark:bg-[#333333] hover:bg-[#B8B8B8] dark:hover:bg-[#565656] text-white',
} as const;

const sizeStyles = {
  normal: 'px-5 h-[40px] shrink-0',
  full: 'w-full h-[40px]',
  small: 'px-0 h-[32px] shrink-0',
  circle: 'w-[40px] h-[40px] shrink-0',
} as const;

export function CButton(props: {
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  color?: keyof typeof colorStyles;
  outline?: boolean;
  size?: keyof typeof sizeStyles;
  'data-testid'?: string;
  disabled?: boolean;
  children: ReactNode;
  height?: number;
  width?: number;
  radius?: number;
  className?: string;
}) {
  const {
    color = 'none',
    size = 'normal',
    outline,
    width,
    height,
    radius,
    className: customClassName,
    children,
  } = props;

  let sizeClass: string = sizeStyles[size] || sizeStyles.normal;
  if (width) sizeClass = sizeClass.replace('px-5', '');
  if (height) sizeClass = sizeClass.replace(/h-\[\d+px\]/, '');

  const colorClass = colorStyles[color] || colorStyles.default;
  const outlineClass = outline ? 'border-solid border-1 border-[rgba(255,255,255,0.3)]' : '';
  const roundedClass = size === 'circle' ? 'rounded-full' : radius ? '' : 'rounded-[10px]';

  return (
    <button
      type={props.type}
      disabled={props.disabled}
      data-testid={props['data-testid']}
      className={`
        group font-bold text-[12px] whitespace-nowrap relative
        text-[#404040] dark:text-white
        cursor-pointer disabled:cursor-auto disabled:pointer-events-none
        ${colorClass} ${sizeClass} ${outlineClass} ${roundedClass}
        ${customClassName || ''}
      `}
      style={{
        width: width || undefined,
        height: height || undefined,
        borderRadius: radius ? `${radius}px` : undefined,
      }}
      onClick={() => {
        props.onClick && props.onClick();
      }}
    >
      <div className="w-full h-full flex items-center gap-[8px] justify-center">{children}</div>
    </button>
  );
}
